import React, { Component } from 'react'
import withLoader from '../../hocs/withLoader'
import ListHeaderComponent from '../ListHeaderComponent'
import LoadingListComponent from '../LoadingListComponent'
import FeedsListComponent from '../FeedsListComponent'
import './ListComponent.css'

class ListComponent extends Component {
  componentDidMount() {
    this.props.fetchFeeds(this.props.url, this.props.name, this.props.homepage)
  }
  componentWillReceiveProps(nextProps) { }
  render() {
    let isCurrentlyFetching =
      this.props.fetchStatus
      && !this.props.fetchStatus[`${this.props.name}IsFetching`]

    return (
      <div className={`ListComponent ${this.props.name.toLowerCase()}`}>
        <ListHeaderComponent props={this.props} />
        {withLoader(isCurrentlyFetching, this.props)(FeedsListComponent, LoadingListComponent)}
      </div>
    )
  }
}

export default ListComponent